import * as React from 'react';

interface IAiContextIconProps extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  color?: string;
}

const AiContextIcon: React.FunctionComponent<IAiContextIconProps> = ({ 
  width = 24, 
  height = 24, 
  className = '', 
  color = 'black',
  ...props 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      className={className}
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Document with lines */}
      <path 
        d="M4 2C3.45 2 3 2.45 3 3V21C3 21.55 3.45 22 4 22H16C16.55 22 17 21.55 17 21V7L13 3H4Z" 
        stroke={color} 
        strokeWidth="1" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Document lines */}
      <path d="M7 9H11" stroke={color} strokeWidth="1" strokeLinecap="round" />
      <path d="M7 12H11" stroke={color} strokeWidth="1" strokeLinecap="round" />
      <path d="M7 15H9" stroke={color} strokeWidth="1" strokeLinecap="round" />
      
      {/* Magnifying glass */}
      <circle cx="16" cy="16" r="4" stroke={color} strokeWidth="1" fill="none" />
      <path d="M19.5 19.5L22 22" stroke={color} strokeWidth="1" strokeLinecap="round" />
      
      {/* Arrow pointing to document */}
      <path d="M13 3V7H17" stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
};

export default AiContextIcon;